/* 🤖 this file was generated by script */
export const wsolidiconNavigationPointer01 = {
  name: 'navigation_pointer_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M21.6 1.46c-.4-.13-.77-.04-.95.01q-.31.1-.68.25L3.01 8.34q-.4.15-.72.3a1.6 1.6 0 0 0-.74.67 1.5 1.5 0 0 0 0 1.38c.2.4.57.58.74.67q.31.15.73.3l6.7 2.61 2.62 6.71q.15.42.3.73c.09.17.27.54.67.74.43.23.95.23 1.38 0 .4-.2.59-.57.67-.74q.15-.32.3-.72l6.62-16.96q.16-.37.25-.68c.05-.18.14-.55.01-.95a1.5 1.5 0 0 0-.94-.94"/></svg>`,
  iconStyle: 'solid',
};
